import { Badge } from "@mantine/core";

export const badgeComponentSettings = Badge.extend({
  defaultProps: {
    variant: "light",
  },
});
